import { createFileRoute } from '@tanstack/react-router';
import AttachmentContent from '../order/view/attachments-content';

export const Route = createFileRoute('/orders/$orderGuid/attachments')({
  component: AttachmentContent,
});
